/* unplugin-vue-components disabled */import { render } from "./tenants.vue?vue&type=template&id=653023af&scoped=true"
import script from "./tenants.vue?vue&type=script&lang=js"
export * from "./tenants.vue?vue&type=script&lang=js"

import "./tenants.vue?vue&type=style&index=0&id=653023af&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653023af"],['__file',"src/pages/tenants/tenants.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "653023af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('653023af', __exports__)) {
    api.reload('653023af', __exports__)
  }
  
  module.hot.accept("./tenants.vue?vue&type=template&id=653023af&scoped=true", () => {
    api.rerender('653023af', render)
  })

}


export default __exports__